import { render, staticRenderFns } from "./high.vue?vue&type=template&id=3c8e2fae&scoped=true&"
import script from "./high.vue?vue&type=script&lang=js&"
export * from "./high.vue?vue&type=script&lang=js&"
import style0 from "./high.vue?vue&type=style&index=0&lang=css&"
import style1 from "./high.vue?vue&type=style&index=1&id=3c8e2fae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8e2fae",
  null
  
)

export default component.exports